/**
 * Reads the JWT payload (middle segment) without verifying the signature.
 * Authorization remains server-side; this is only for client hints (tenant, etc.).
 */
export function readJwtPayload(token: string): Record<string, unknown> | null {
  if (!token || typeof token !== 'string') {
    return null;
  }
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4));
    return JSON.parse(atob(b64 + pad)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function readTenantIdFromJwt(token: string): number | null {
  const p = readJwtPayload(token);
  if (!p) {
    return null;
  }
  const keys = ['tenantId', 'tenant_id', 'schoolId', 'school_id', 'tid'];
  for (const k of keys) {
    const v = p[k];
    if (typeof v === 'number' && !Number.isNaN(v)) {
      return v;
    }
    if (typeof v === 'string' && /^\d+$/.test(v)) {
      return Number(v);
    }
  }
  return null;
}
